<template>
  <div class="s-confirmation-form__box" :class="completedClass">
    <Loader v-if="isLoading"></Loader>

    <Alert
      v-if="!isLoading && errorMsgs.length && !hasOtpError"
      key="submit-errors"
      dismiss-by-native=""
      type="danger"
      :messages="errorMsgs"
      @close="removeErrors"></Alert>

    <!--head-->
    <div class="s-confirmation-form__box__head">
      <div class="s-confirmation-form__box__title">{{ formTitle }}</div>
      <div class="s-confirmation-form__box__icon"></div>
    </div>

    <!--body-->
    <div v-if="!completedStep" class="s-confirmation-form__box__body">
      <div class="s-confirmation-form__info">
        {{ dictionary.emailConfirmationDesc }}
        <span>{{ modifiedEmail }}</span>
      </div>

      <OtpInputs
        :has-otp-error="hasOtpError"
        :resend-otp-code="resendOtpCode"
        @reset-form="resetForm"
        @confirm-email-otp="confirmOtp"></OtpInputs>
      <div
        v-if="!isLoading && errorMsgs.length && hasOtpError"
        class="field-validation-error">
        {{ errorMsgs[0] }}
      </div>

      <div class="s-confirmation-form__resend">
        <button type="button" @click="resendOtp">
          {{ dictionary.resendCode }}
        </button>
      </div>

      <button
        type="submit"
        class="p-contact__submit-btn"
        :disabled="isButtonDisabled"
        @click="validateOtp">
        <span>{{ dictionary.btnLabel }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import postRequestHandler from '../../../lib/postRequestHandler'
import getErrorMessage from '../../../lib/getErrorMessage'
import OtpInputs from './../RegisterForm/OtpInputs.vue'
import Loader from '../Shared/Loader.vue'
import Alert from '../Shared/Alert.vue'
export default {
  components: { OtpInputs, Loader, Alert },
  props: {
    email: {
      default: '',
      type: String,
    },
    areaCode: {
      default: '',
      type: String,
    },
    mobileTelephone: {
      default: '',
      type: String,
    },
    firstName: {
      default: '',
      type: String,
    },
    lastName: {
      default: '',
      type: String,
    },
    showEmailOtp: {
      default: false,
      type: Boolean,
    },
    showTelephoneOtp: {
      default: false,
      type: Boolean,
    },
  },
  emits: ['confirm-email-otp', 'prev-step-completed', 'send-email-otp'],

  data() {
    return {
      isLoading: false,
      errorMsgs: [],
      isButtonDisabled: true,
      completedStep: false,
      otpCode: '',
      hasError: false,
      hasOtpError: false,
      resendOtpCode: false,
    }
  },
  computed: {
    completedClass() {
      return this.completedStep ? 's-confirmation-form__box--completed' : ''
    },

    formTitle() {
      return this.completedStep
        ? this.dictionary.emailConfirmed
        : this.dictionary.emailConfirmationTitle
    },

    modifiedEmail() {
      const [firstPart, domain] = this.email.split('@')

      const modifiedArray = firstPart
        .split('')
        .map((char, index) => (index === 0 ? char : '•'))

      return modifiedArray.join('') + '@' + domain
    },
  },

  methods: {
    resetForm(code) {
      if (code.length === 0) {
        this.hasOtpError = false
        this.errorMsgs = []
      }
      this.isButtonDisabled = true
    },
    confirmOtp(code) {
      this.otpCode = code
      if (this.otpCode.length === 6) {
        this.isButtonDisabled = false
      } else {
        this.isButtonDisabled = true
      }
    },

    async validateOtp() {
      if (this.isLoading) {
        return false
      }

      this.isLoading = true

      const postData = {
        email: this.email,
        firstName: this.firstName,
        lastName: this.lastName,
        areaCode: this.areaCode,
        phone: this.mobileTelephone,
        phoneOTPRequired: this.showTelephoneOtp ? true : false,
        userSessionId: this.configuration.userSessionId,
        emailOtp: this.otpCode,
        language: document.documentElement.lang,
      }

      await postRequestHandler({
        postData,
        endpoint: this.configuration.endpointValidateEmailOtp,
        successCallback: this.handleSuccess,
        errorCallback: this.handleError,
        refreshTokenHandler: this.configuration.refresh,
        captchaAction: this.configuration.emailOtpCatpchaAction,
      })
    },

    handleSuccess() {
      this.isLoading = false
      this.errorMsgs = []

      this.completedStep = true

      if (this.showEmailOtp && this.showTelephoneOtp) {
        this.$emit('prev-step-completed', this.completedStep)
      } else {
        this.$emit('send-email-otp')
      }
    },

    async resendOtp() {
      if (this.isLoading) {
        return false
      }

      this.hasError = false
      this.isLoading = true
      this.hasOtpError = false

      const postData = {
        email: this.email,
        firstName: this.firstName,
        lastName: this.lastName,
        areaCode: this.areaCode,
        phone: this.mobileTelephone,
        phoneOTPRequired: false,
        userSessionId: this.configuration.userSessionId,
        emailOtp: this.otpCode,
        language: document.documentElement.lang,
      }

      await postRequestHandler({
        postData,
        endpoint: this.configuration.endpointEmailResendOtp,
        successCallback: this.resendSuccess,
        errorCallback: this.resendhandleError,
        refreshTokenHandler: this.configuration.refresh,
        captchaAction: this.configuration.emailResendOtpCatpchaAction,
      })
    },

    resendSuccess() {
      this.isLoading = false
      this.errorMsgs = []
      this.resendOtpCode = true
    },

    resendhandleError(messages) {
      this.isLoading = false
      this.hasError = true
      this.errorMsgs = getErrorMessage(
        messages,
        this.dictionary.defaultErrorMessage
      )

      //await this.$nextTick()
      //  lib.scrollToError()
    },

    handleError(messages) {
      this.isLoading = false
      this.hasOtpError = true
      this.errorMsgs = getErrorMessage(
        messages,
        this.dictionary.defaultErrorMessage
      )

      //await this.$nextTick()
      //  lib.scrollToError()
    },

    removeErrors() {
      this.errorMsgs = []
    },
  },
}
</script>
